import { render, staticRenderFns } from "./numeric-score-entry.vue?vue&type=template&id=8394c8ba&scoped=true&"
import script from "./numeric-score-entry.vue?vue&type=script&lang=js&"
export * from "./numeric-score-entry.vue?vue&type=script&lang=js&"
import style0 from "./numeric-score-entry.vue?vue&type=style&index=0&id=8394c8ba&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8394c8ba",
  null
  
)

export default component.exports